import React from 'react';
import PropTypes from 'prop-types';

function PhoneIcon({ color, width, height }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path d="M15.4 20.0001C11.3173 19.9948 7.40331 18.3706 4.5164 15.4837C1.62949 12.5968 0.00529192 8.68282 0 4.60011C0 3.38012 0.484642 2.21009 1.34731 1.34742C2.20998 0.484756 3.38 0.000114295 4.6 0.000114295C4.85834 -0.00185351 5.11625 0.0215926 5.37 0.0701142C5.61531 0.106415 5.85647 0.166704 6.09 0.250114C6.25425 0.307744 6.40061 0.407248 6.51461 0.538787C6.62861 0.670325 6.7063 0.829343 6.74 1.00011L8.11 7.00011C8.14693 7.16298 8.14248 7.33249 8.09706 7.4932C8.05165 7.6539 7.96671 7.80067 7.85 7.92011C7.72 8.06011 7.71 8.07011 6.48 8.71011C7.46499 10.871 9.1932 12.6063 11.35 13.6001C12 12.3601 12.01 12.3501 12.15 12.2201C12.2694 12.1034 12.4162 12.0185 12.5769 11.9731C12.7376 11.9276 12.9071 11.9232 13.07 11.9601L19.07 13.3301C19.2353 13.3685 19.3881 13.4483 19.5141 13.562C19.64 13.6757 19.735 13.8196 19.79 13.9801C19.8744 14.2175 19.938 14.4617 19.98 14.7101C20.0202 14.9614 20.0403 15.2156 20.04 15.4701C20.0216 16.6849 19.5233 17.8431 18.654 18.6918C17.7847 19.5405 16.6149 20.0108 15.4 20.0001Z" fill={color} />
    </svg>
  );
}

PhoneIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

PhoneIcon.defaultProps = {
  color: '#7ED321',
  width: '21',
  height: '20',
};

export default React.memo(PhoneIcon);
